export const isIE = () => {
	if (!window.navigator) return false
	if (!window.navigator.userAgent) return false
	const userAgent = window.navigator.userAgent
	for (const check of ['MSIE ', 'Trident/']) {
		// MSIE = IE 10-, Trident/ = IE 11
		if (userAgent.indexOf(check) >= 0) return true
	}
	return false
}
